import React from 'react'
import APSCMetlinkReportComponent from '../Components/MetlinkReport/APSCMetlinkReportComponent' 

function APSCMetlinkReportPage() {
    return (
        <APSCMetlinkReportComponent/>
    )
}

export default APSCMetlinkReportPage